import { render, staticRenderFns } from "./RelatorioQuantidadeTermosPesquisados.vue?vue&type=template&id=91555568"
import script from "./RelatorioQuantidadeTermosPesquisados.vue?vue&type=script&lang=js"
export * from "./RelatorioQuantidadeTermosPesquisados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports